import {
  BUILD_AGENT_MODELS as BUILD_AGENT_MODEL_IDS,
  DEFAULT_BUILD_AGENT_MODEL,
  resolveBuildAgentModel,
  type BuildAgentModel,
} from '@volley/crucible/runtime/agent-runtime-contract.js';

export const BUILD_AGENT_MODELS = [
  {
    id: 'claude-opus-4-8',
    label: 'Opus 4.8',
    hint: 'Default - the best choice for most Foundry builds.',
  },
  {
    id: 'claude-fable-5',
    label: 'Fable 5',
    hint: 'Alternative for especially complex or exploratory builds.',
  },
] as const;

export { DEFAULT_BUILD_AGENT_MODEL };
export type { BuildAgentModel };

// Compile-time and runtime drift guard: labels are UI metadata, while the
// accepted model ids remain owned by the shared host contract.
if (
  BUILD_AGENT_MODELS.length !== BUILD_AGENT_MODEL_IDS.length ||
  BUILD_AGENT_MODELS.some((model) => !BUILD_AGENT_MODEL_IDS.includes(model.id))
) {
  throw new Error('Foundry build-model labels are out of sync with the runtime contract.');
}

export function normaliseBuildAgentModel(value: string | null | undefined): BuildAgentModel {
  return resolveBuildAgentModel(value);
}

export function buildAgentModelLabel(value: string | null | undefined): string {
  const model = normaliseBuildAgentModel(value);
  return BUILD_AGENT_MODELS.find((candidate) => candidate.id === model)?.label ?? 'Opus 4.8';
}
